// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__nlmpQ","content":"GlobalSearch_content__17TH4"};